import { Component, OnInit, Input, forwardRef, HostListener, ElementRef, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { KeyValuePair } from '../../../models/common/keyValuePair';
import { BudgetFilter } from '../../../models/budgets/budget.filter';
import { Event } from '@angular/router';

@Component({
	selector: 'input-typeahead',
	templateUrl: './input-typeahead.component.html',
	styleUrls: ['./input-typeahead.component.css'],
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => InputTypeaheadComponent),
			multi: true
		}
	]
})
export class InputTypeaheadComponent implements ControlValueAccessor {

	@Input('value') _value: KeyValuePair;
	@Input() isDisabled: boolean = false;
	@Input() data: KeyValuePair[];
	@Input() showNull: boolean = true;
	@Output() onSearchTextChange: EventEmitter<string> = new EventEmitter<string>()
	
	displayText: string = null;
	showSelect: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.displayText = val.value;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _elementRef: ElementRef
	) { }

	@HostListener('document:click', ['$event'])
	clickout(event) {
		if (!this._elementRef.nativeElement.contains(event.target))
			this.showSelect = false;
	}

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	onSelect(keyValuePair){
		this.value = keyValuePair;
		this.showSelect = false;
	}

	openSelect(){
		this.showSelect = true;
	}

	onTextChange(event: Event){
		if(this.displayText.length >= 3)
			this.onSearchTextChange.emit(this.displayText);
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/input-typeahead/input-typeahead.component.ts